module.exports = __webpack_public_path__ + "static/media/error.09673f4b.png";